RivalIQ.module('export.models.factories', function (factories, App, Backbone, Marionette, $, _) {

    'use strict';

    factories.png = function (model) {
        const slides = [
            model.getExportPage()
        ];

        let props = model.config.getProps();
        props = _.pick(props, 'landscapeId', 'companySetDescriptor', 'timePeriod', 'activeSources', 'focusCompanyId');

        const attrs = _.extend({
            branding: RivalIQ.state.view.getActiveBranding().toJSON(),
            activeBranding: RivalIQ.utils.branding.getActiveBrandingType(),
            slides: slides
        }, props);

        model.set(attrs, {
            silent: true
        });
    };
});
